import { useContext } from 'react';
import { BrandInfoContext } from '@core-ui/brand-info-provider';
import useEnabledFeature from '../../useEnabledFeature';
import ABSegmentContext from '../../../components/ab-segment-context';

const useMixedGrid = (): boolean => {
  const { abbrBrand } = useContext(BrandInfoContext);
  const segments = useContext(ABSegmentContext);

  const featureEnabled = useEnabledFeature('cat-mixed-model-grid');
  const mixedGridSegmentEnabled = segments[`${abbrBrand}44`] === 'b';

  return featureEnabled && mixedGridSegmentEnabled;
};

export default useMixedGrid;
